import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js';
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader';
import stop_png from '@/components/images/stop_logo.png';
import { ObstacleSetting } from "./setting";
import data_view_pb from '@/proto/data_view_pb.js';

const SLOWDOWN_POLYGON_COLOR = 0x18c918;
const NON_NEGLIGIBLE_POLYGON_COLOR = 0xff3b30;
const ERASED_POLYGON_COLOR = 0x808080;
const ERASED_POLYGON_EMISSIVE = 0x404040;
const SLOWDOWN_NEGLIGIBLE =
  data_view_pb.ObjectNegligibleType.OBJECT_SLOWDOWN_NEGLIGIBLE;
const NON_NEGLIGIBLE =
  data_view_pb.ObjectNegligibleType.OBJECT_NON_NEGLIGIBLE;

let model_map = new Map();
const dracoLoader = new DRACOLoader();
dracoLoader.setDecoderPath('libs/draco/gltf/');
const loader = new GLTFLoader().setPath('model/gltf/');
loader.setDRACOLoader(dracoLoader);
let playgon_Material = new THREE.LineBasicMaterial({ color: 0xf58220 });
let playgonMaterialSlowdown = null;
let playgonMaterialNonNegligible = null;
let playgonMaterialErased = null;
let meshMaterialSlowdown = null;
let meshMaterialNonNegligible = null;
let meshMaterialErased = null;

export function createObstaclePolygon(obstacle, origin, callback) {
  let line2 = CreateExtrudeGeometryPolygon(obstacle, origin);
  return line2;
}

export function create_trajectory(obstacle, origin) {
  let line = null;
  //规划线
  if (obstacle.trajectoryList && obstacle.trajectoryList.length > 0) {
    let material = CreateoOstacleTrajectoryMateial();
    const points = [];

    obstacle.trajectoryList.forEach((e) => {
      points.push(new THREE.Vector3(origin.x + e.x, origin.y + e.y, 0.02));
    });
    const geometry = new THREE.BufferGeometry().setFromPoints(points);
    line = new THREE.Line(geometry, material);
    line.renderOrder = 10;
  } else if (
    obstacle.preTrajectoryList &&
    obstacle.preTrajectoryList.length > 0
  ) {
    if(obstacle.preTrajectoryList.length>1){
    }
    let material = CreateoOstacleTrajectoryMateial();
    line = new THREE.Group();
    for (let i = 0; i < obstacle.preTrajectoryList.length; i++) {
      const points = [];
      obstacle.preTrajectoryList[i].trajectoryPointList.forEach((e) => {
        points.push(
          new THREE.Vector3(origin.x + e.point.x, origin.y + e.point.y, 0.02),
        );
      });
      const geometry = new THREE.BufferGeometry().setFromPoints(points);
      let line_sub = new THREE.Line(geometry, material);
      line_sub.renderOrder = 10;
      line.add(line_sub);
    }
  }
  return line;
}

/**
 * 创障碍物立方体
 * @param {*} obstacle
 * @param {*} origin
 * @returns
 */
function CreateExtrudeGeometryPolygon(obstacle, origin) {
  const shape = new THREE.Shape();
  let position = {};
  obstacle.polygon.pointList.forEach((e, index) => {
    if (index == 0) {
      shape.moveTo(origin.x + e.x, origin.y + e.y);
      position = {
        x: origin.x + e.x,
        y: origin.y + e.y,
      };
    } else {
      shape.lineTo(origin.x + e.x, origin.y + e.y);
    }
  });
  const extrudeSettings = {
    depth: obstacle.height,
    bevelEnabled: false,
  };
  const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
  geometry.computeBoundingBox();

  const edges = new THREE.EdgesGeometry(geometry);
  const mesh = new THREE.LineSegments(
    edges,
    getPolygonEdgeMaterial(obstacle.negligibleType, obstacle.erased),
  );
  // mesh.add(line);
  mesh.positionEX = position;

  //障碍物面：

  let elementType = obstacle.obstacleType || 0;
  let key = `obstacle_${elementType}`;
  let modelSetting = ObstacleSetting[key]?.modelSetting;
  const fillMaterial = getPolygonFillMaterial(obstacle.negligibleType, obstacle.erased);
  if (fillMaterial) {
    const mesh2 = new THREE.Mesh(geometry, fillMaterial);
    mesh.add(mesh2);
  } else if (modelSetting && !modelSetting.isModel) {
    let material = getMateial(obstacle.obstacleType);
    const mesh2 = new THREE.Mesh(geometry, material);
    mesh.add(mesh2);
  }
  //规划线

  return mesh;
}

function getSlowdownEdgeMaterial() {
  if (!playgonMaterialSlowdown) {
    playgonMaterialSlowdown = new THREE.LineBasicMaterial({
      color: SLOWDOWN_POLYGON_COLOR,
    });
  }
  return playgonMaterialSlowdown;
}

function getNonNegligibleEdgeMaterial() {
  if (!playgonMaterialNonNegligible) {
    playgonMaterialNonNegligible = new THREE.LineBasicMaterial({
      color: NON_NEGLIGIBLE_POLYGON_COLOR,
    });
  }
  return playgonMaterialNonNegligible;
}

function getErasedEdgeMaterial() {
  if (!playgonMaterialErased) {
    playgonMaterialErased = new THREE.LineBasicMaterial({
      color: ERASED_POLYGON_COLOR,
    });
  }
  return playgonMaterialErased;
}

// 边框颜色：被忽略障碍物灰色，slowdown 绿色、non_negligible 红色，其余沿用默认黄色
function getPolygonEdgeMaterial(negligibleType, erased) {
  if (erased) {
    return getErasedEdgeMaterial();
  }
  if (negligibleType === SLOWDOWN_NEGLIGIBLE) {
    return getSlowdownEdgeMaterial();
  }
  if (negligibleType === NON_NEGLIGIBLE) {
    return getNonNegligibleEdgeMaterial();
  }
  return playgon_Material;
}

function getSlowdownFillMaterial() {
  if (!meshMaterialSlowdown) {
    meshMaterialSlowdown = new THREE.MeshBasicMaterial({
      color: SLOWDOWN_POLYGON_COLOR,
      side: THREE.DoubleSide,
      opacity: 0.3,
      transparent: true,
    });
  }
  return meshMaterialSlowdown;
}

function getNonNegligibleFillMaterial() {
  if (!meshMaterialNonNegligible) {
    meshMaterialNonNegligible = new THREE.MeshBasicMaterial({
      color: NON_NEGLIGIBLE_POLYGON_COLOR,
      side: THREE.DoubleSide,
      opacity: 0.3,
      transparent: true,
    });
  }
  return meshMaterialNonNegligible;
}

function getErasedFillMaterial() {
  if (!meshMaterialErased) {
    meshMaterialErased = new THREE.MeshPhongMaterial({
      color: ERASED_POLYGON_COLOR,
      emissive: ERASED_POLYGON_EMISSIVE,
      side: THREE.DoubleSide,
      opacity: 0.3,
      transparent: true,
    });
  }
  return meshMaterialErased;
}

// 填充面颜色：被忽略障碍物灰色，slowdown 绿色、non_negligible 红色，其余返回 null（沿用原模型/贴图逻辑）
function getPolygonFillMaterial(negligibleType, erased) {
  if (erased) {
    return getErasedFillMaterial();
  }
  if (negligibleType === SLOWDOWN_NEGLIGIBLE) {
    return getSlowdownFillMaterial();
  }
  if (negligibleType === NON_NEGLIGIBLE) {
    return getNonNegligibleFillMaterial();
  }
  return null;
}

let material_map = new Map();
function getMateial(elementType) {
  elementType = elementType || 0;
  const key = `obstacle_${elementType}`;
  if (material_map.has(key)) {
    return material_map.get(key);
  }
  const mSetting = ObstacleSetting[key];
  let material = new THREE.MeshBasicMaterial(mSetting.mateialSetting.setting);
  // let material = new THREE.LineBasicMaterial({ color: mSetting.mateialSetting.setting.color })
  // material.opacity =0.2;
  material.opacity = mSetting.mateialSetting.setting.opacity;
  material.transparent = true;
  material_map.set(key, material);
  return material;
}

let ostacleTrajectoryMateial = null;
const CreateoOstacleTrajectoryMateial = () => {
  if (ostacleTrajectoryMateial) return ostacleTrajectoryMateial;
  ostacleTrajectoryMateial = new THREE.LineBasicMaterial({
    color: 0xd71345,
  });
  return ostacleTrajectoryMateial;
};
//文字
const fontLoader = new FontLoader();
let font = null;
let fontMaterial = null;
export const loadFontModel = (text, size, callback) => {
  if (!font) {
    fontLoader.load('fonts/helvetiker_regular.typeface.json', function (eFont) {
      font = eFont;
      callback(createText(text, size, font));
    });
  } else {
    callback(createText(text, size, font));
  }
};

function createText(text, size = 0.3, font) {
  const geometry = new TextGeometry(text, {
    font: font,
    size: size,
    height: 0.05,
  });
  geometry.computeBoundingBox();
  if (!fontMaterial)
    fontMaterial = new THREE.MeshBasicMaterial({
      color: 0xed1941,
      side: THREE.DoubleSide,
    });
  fontMaterial.transparent = true;
  fontMaterial.depthTest = false;

  let mesh = new THREE.Mesh(geometry, fontMaterial);
  return mesh;
}

export const obStacleTypeEnum = [
  { key: 0, cName: '未知物', eName: 'misc' },
  { key: 1, cName: '小汽车', eName: 'car' },
  { key: 2, cName: '卡车', eName: 'truck' },
  { key: 3, cName: '公交车', eName: 'bus' },
  { key: 4, cName: '行人', eName: 'pedestrian' },
  { key: 5, cName: '自行车，摩托车', eName: 'bicycle' },
  { key: 6, cName: '三轮车', eName: 'tricycle' },
  { key: 100, cName: '静态元素，比如花坛', eName: 'map_point_cluster' },
  { key: 101, cName: '锥桶', eName: 'traffic_cone' },
  { key: 102, cName: '低矮障碍物', eName: 'low_profile_obstacle' },
  { key: 103, cName: '停放的自行车', eName: 'unmanned_bicycle' },
  { key: 200, cName: '虚拟障碍物', eName: 'artificial_object' },
];



let promiseMap = new Map();
//加载模型
export const loadModel = (obstacle, callback) => {
  let elementType = obstacle.obstacleType || 0;
  let key = `obstacle_${elementType}`;
  let modelSetting = ObstacleSetting[key]?.modelSetting;
  if (modelSetting && modelSetting.isModel) {
    createModel(obstacle, modelSetting, callback);
  }
};

function createModel(obstacle, setting, callback) {
  if (model_map.has(obstacle.obstacleType)) {
    Promise.resolve().then(() => {
      let glb_map = model_map.get(obstacle.obstacleType);
      let glb = glb_map.clone();
      glb.size = glb_map.size;
      glb.rotationInit = glb_map.rotationInit;
      callback(glb);
    });
  } else if (promiseMap.has(obstacle.obstacleType)) {
    let p = promiseMap.get(obstacle.obstacleType);
    p.then((model) => {
      let glb = model.clone();
      glb.rotationInit = model.rotationInit;
      glb.size = model.size;
      callback(glb);
    });
  } else {
    let p;
    if (setting.modelType == 'glb') {
      p = loadGLB(obstacle, setting);
    } else if (setting.modelType == 'obj') {
      p = loadOBJ(obstacle, setting);
    } else {
      return;
    }
    p.then((model) => {
      let glb = model.clone();
      glb.size = model.size;
      glb.rotationInit = model.rotationInit;
      callback(glb);
    });
  }
}
function loadOBJ(obstacle, setting) {
  let promise = new Promise((resolve, reject) => {
    var mtlLoader = new MTLLoader();
    mtlLoader.setPath('model/obj/');
    mtlLoader.load(`${setting.path}/file.mtl`, function (materials) {
      materials.preload();
      var objLoader = new OBJLoader();
      objLoader.setMaterials(materials);
      objLoader.setPath('model/obj/');
      objLoader.load(`${setting.path}/file.obj`, function (object) {
        object.up = new THREE.Vector3(0, 0, 1);
        object.rotation.set(
          setting.rotation.x,
          setting.rotation.y,
          setting.rotation.z,
        );
        object.rotationInit = setting.rotation;

        const box = new THREE.Box3();
        box.expandByObject(object);
        let v3 = new THREE.Vector3();
        box.getSize(v3);
        object.size = v3;

        // object.scale.set(setting.scale.x, setting.scale.y, setting.scale.z)
        model_map.set(obstacle.obstacleType, object);
        resolve(object);
      });
    });
  });
  promiseMap.set(obstacle.obstacleType, promise);
  return promise;
}

function loadGLB(obstacle, setting) {
  let promise = new Promise((resolve, reject) => {
    loader.load(
      setting.path,
      (gltf) => {
        let glb = gltf.scene.children[0];
        glb.up = new THREE.Vector3(0, 0, 1);
        glb.rotation.set(
          setting.rotation.x,
          setting.rotation.y,
          setting.rotation.z,
        );
        glb.rotationInit = setting.rotation;
        // glb.scale.set(setting.scale.x, setting.scale.y, setting.scale.z)

        const box = new THREE.Box3();
        box.expandByObject(glb);
        let v3 = new THREE.Vector3();
        box.getSize(v3);
        glb.size = v3;

        model_map.set(obstacle.obstacleType, glb);
        resolve(glb);
      },
      null,
      (err) => {
        reject(err);
        console.log(err);
      },
    );
  });
  promiseMap.set(obstacle.obstacleType, promise);
  return promise;
}

export function getRotationFromTrajectory(start, end) {
  let step_x = end.x - start.x;
  let step_y = end.y - start.y;
  let rotation = Math.atan2(step_y, step_x);
  return rotation;
}

export function create_routing_stop(x, y, angle, type, size) {
  let { length, height, width, backEdgeToCenter } = size;
  let group = new THREE.Group();
  group.renderOrder = -10000;
  let center = {
    x: length / 2 - backEdgeToCenter,
    y: 0,
    z: 0.01,
  };
  let sphere = null;
  {
    let color = type == 1 ? 0xaa2116 : 0xdf9464;
    const geometry = new THREE.BoxGeometry(length, width, 0.01);
    const material = new THREE.MeshBasicMaterial({
      color,
      side: THREE.DoubleSide,
      opacity: 0.2,
      transparent: true,
    });
    let sphere_box = new THREE.Mesh(geometry, material);
    sphere_box.position.set(center.x, center.y, 0);
    sphere = new THREE.Group();
    sphere.add(sphere_box);

    sphere.position.set(x, y, 0);
    sphere.rotation.set(0, 0, angle);
    group.add(sphere);
    {
      getStopTexture().then((material) => {
        const geometry = new THREE.BoxGeometry(length / 4, width / 4, 0.01);
        const stoplogo = new THREE.Mesh(geometry, material);
        stoplogo.position.set(0, 0, 0.01);
        // stoplogo.rotation.set(0, 0, angle);
        sphere.add(stoplogo);
      });
    }
  }
  {
    let x_end = Math.cos(angle) * 3;
    let y_end = Math.sin(angle) * 3;
    const material = new THREE.LineBasicMaterial({ color: 0xf58220 });
    const points = [];
    points.push(new THREE.Vector3(x, y, 0.1));
    points.push(new THREE.Vector3(x + x_end, y + y_end, 0.1));
    const geometry = new THREE.BufferGeometry().setFromPoints(points);
    const line = new THREE.Line(geometry, material);
    group.add(line);
    {
      let heartShape = new THREE.Shape();
      heartShape.moveTo(0, 0.3);
      heartShape.lineTo(0, -0.3);
      heartShape.lineTo(0 + 2, 0);
      heartShape.autoClose = true;
      const geometry_shape = new THREE.ShapeGeometry(heartShape);
      const material_shape = new THREE.MeshBasicMaterial({
        color: 0xf58220,
        side: THREE.DoubleSide,
      });
      const mesh = new THREE.Mesh(geometry_shape, material_shape);
      // mesh.up = new THREE.Vector3(0, 0, 1)
      mesh.position.set(x + x_end, y + y_end, 0.1);
      mesh.rotation.set(0, 0, angle);
      mesh.renderOrder = -99;
      // mesh.matrixAutoUpdate = false;
      group.add(mesh);
    }
  }
  return group;
}
let promise_stop_logo = null;
export const getStopTexture = () => {
  if (!promise_stop_logo) {
    promise_stop_logo = new Promise((resolve, reject) => {
      const loader = new THREE.TextureLoader();
      loader.load(
        stop_png,
        (texture) => {
          const material = new THREE.MeshBasicMaterial({
            map: texture,
            transparent: true,
          });
          resolve(material);
        },
        undefined,
        function (err) {
          console.error(err);
          reject(err);
        },
      );
    });
  }
  return promise_stop_logo;
};
